import { useMemo, useState } from 'react'
import {
	useGetAnalysisWages,
} from '../../../core/services/react-query/analysis'
import { ClipLoader } from 'react-spinners'
import { getMainTheme } from '../../../core/utils/theme'
import EChart from '../../layout/EChart'
import { useMainContext } from '../../../core/contexts/main'
import AnalysisDateSelect from './AnalysisDateSelect'

const dateOptions = ['monthly', 'this-year', 'custom']

const StakingHistoryChart = () => {
	const { theme, lang } = useMainContext()
	const [date, setDate] = useState('monthly')
	const [monthlyDate, setMonthlyDate] = useState()
	const [customDates, setCustomDates] = useState([])

	const params = useMemo(() => {
		if (date === 'monthly' && !!monthlyDate) {
			if (lang === 'fa') {
				try {
					const dateInLocale = new Date(monthlyDate).toLocaleDateString('fa-IR-u-nu-latn')
					const splittedDateInLocale = dateInLocale.split('/')
					const daysToAdd = parseInt(splittedDateInLocale[1]) > 6 ? 30 : 31
					let from = new Date(monthlyDate)
					let to = new Date(monthlyDate)
					to.setDate(to.getDate() + daysToAdd)
					return { dateFrom: from.toISOString(), dateTo: to.toISOString() }
				} catch (_) { }
			} else {
				// TODO: english dates
			}
		}

		if (date === 'custom' && customDates?.length > 1) {
			return {
				dateFrom: new Date(customDates[0]).toISOString(),
				dateTo: new Date(customDates[1]).toISOString(),
			}
		}
	}, [date, customDates, monthlyDate])

	const { data: fiatData, isLoading: fiatDataLoading } = useGetAnalysisWages({
		params,
		search: `?search=cause.label&query=${'staking'}`,
	})


	const extractBarChartValues = (data) => {
		if (!data?.length) return { labels: [], values: [] }
		const labels = data.map(item => item.currency.toUpperCase())
		const values = data.map(item => item.volumes) // or item.count or item.wages
		return { labels, values }
	}

	const getLeftMarginByMaxValue = (mx) => {
		if (mx > 100000000) {
			return '80px'
		} else if (mx < 1) {
			return '60px'
		}
		return '40px'
	}


	const options = useMemo(() => {
		if (!fiatData?.length) return {}

		const { labels, values } = extractBarChartValues(fiatData)

		const mx = Math.max(...values)
		const left = getLeftMarginByMaxValue(mx)

		return {
			color: ['#1a8bab'],
			grid: {
				left,
			},
			xAxis: {
				type: 'category',
				data: labels,
			},
			yAxis: {
				type: 'value',
				splitLine: {
					lineStyle: {
						color: theme === 'dark' ? '#c3c5b720' : '#00000020',
						type: 'dashed',
					},
				},
			},
			tooltip: {
				trigger: 'axis',
				formatter: function (params) {
					const data = params[0];
					return `${data.name}<br/>Volume: ${data.value}`;
				},
			},
			series: [
				{
					data: values,
					type: 'bar',
				},
			],
		}
	}, [fiatData, theme])

	return (
		<div className={'dark:text-gray-200 text-sm'}>
			<div
				className={`
            rounded-md bg-gray-100 dark:bg-mainBg py-3 px-1 shadow-md
            border-[1px] border-slate-500 border-opacity-30 relative h-[420px]
                `}
			>
				{fiatDataLoading ? (
					<div className={'absolute left-0 top-0 w-full h-full flex items-center justify-center'}>
						<ClipLoader color={getMainTheme().active} size={20} />
					</div>
				) : null}

				<div className={'flex lg:items-center lg:flex-row flex-col gap-2'}>
					<AnalysisDateSelect
						value={date}
						onChange={setDate}
						options={dateOptions}
						customDates={customDates}
						onCustomChange={setCustomDates}
						monthlyDate={monthlyDate}
						onMonthlyChange={setMonthlyDate}
					/>
				</div>

				<EChart option={options} style={{ width: '100%', height: '360px' }} dir={'ltr'} />
			</div>
		</div>
	)
}

export default StakingHistoryChart
